<div class="tile-container" [ngClass]="[bgColor, pointerCssClass]" [attr.data-type]="'tile'"  (click)="dispatchEvt($event)" style="margin-left: {{marginLeft}};">

  <div class="text-container" >
    <p [attr.data-type]="'tile'" (click)="dispatchEvt($event)" >
      <mat-icon *ngIf="showWarningIcon">warning</mat-icon>
      {{displayText}}
    </p>
  </div>

  <div class="icon-container" *ngIf="showDetailIcon">
    <mat-icon class="icon" [ngClass]="pointerCssClass" matTooltip="Visualizza" [attr.data-type]="'icon'" (click)="dispatchEvt($event)">
      visibility
    </mat-icon>
  </div>
</div>
